import boss from '../../../assets/images/production/applicationDev/BOSS.png'
import bossActive from '../../../assets/images/production/applicationDev/BOSS-hover.png'
import ace from '../../../assets/images/production/applicationDev/ACE.png'
import aceActive from '../../../assets/images/production/applicationDev/ACE-hover.png'
import bosspages from '../../../assets/images/production/applicationDev/BOSS-pages.png'
import acepages from '../../../assets/images/production/applicationDev/ACE-pages.png'
import ball from '../../../assets/images/production/applicationDev/ball-s.png'
import leftBall from '../../../assets/images/production/applicationDev/left-ball.png'

import { Tabs } from 'antd'
import styles from './style.module.scss'

const applicationList = [
    {
        key: '1',
        label: (<div className={styles['application-label']}><img className={styles['normal']} src={boss} alt="" /><img className={styles['active']} src={bossActive} alt="" /></div>),
        content: (<>
            <div className={`introduction-container ${styles['introduction-container']}`}>
                <img src={ball} alt="" />
                <div className={`introduction-title ${styles['introduction-title']}`}>
                    <div className={`title-wrapper ${styles['title-wrapper']}`}>
                        <img src={leftBall} alt="" />
                        <div className={`title-container ${styles['title-container']}`}>
                            <div>
                                <p><span>BOSS</span><span>—— 可视化大屏开发工具</span></p>
                                <p>可视化大屏开发工具是一款主打大屏应用快速开发交付的可视化工具，仅通过简单的图形化界面操作，即可高效、便捷地搭建具有专业水准的可视大屏界面。该工具支持多源数据对接，实现数据视图联动，满足客户会议展览、业务监控、风险预警、地理分析等多种业务展示需求，助力客户高效决策。</p>
                            </div>
                            <img src={bosspages} alt="" />
                        </div>
                    </div>
                </div>
            </div>
            <div className={styles['feature-container']}>
                <p>产品特色</p>
                <div className={styles['feature-content']}>
                    <div className={`feature-item ${styles['feature-item']}`}>
                        <div className={styles['img']}></div>
                        <p>低代码</p>
                        <p>优化开发流程，一站式低代码构建</p>
                    </div>
                    <div className={`feature-item ${styles['feature-item']}`}>
                        <div className={styles['img']}></div>
                        <p>高效率</p>
                        <p>快速构建可视化页面，效率提升高达215%</p>
                    </div>
                    <div className={`feature-item ${styles['feature-item']}`}>
                        <div className={styles['img']}></div>
                        <p>多模板</p>
                        <p>内置908种大屏案例，多种模板参考选择</p>
                    </div>
                    <div className={`feature-item ${styles['feature-item']}`}>
                        <div className={styles['img']}></div>
                        <p>沉浸体验</p>
                        <p>尽享震撼视觉效果，酷炫立体组件，全方位多视角</p>
                    </div>
                </div>
            </div>
        </>)
    },
    {
        key: '2',
        label: (<div className={styles['application-label']}><img className={styles['normal']} src={ace} alt="" /><img className={styles['active']} src={aceActive} alt="" /></div>),
        content: (<>
            <div className={`introduction-container ${styles['introduction-container']}`}>
                <img src={ball} alt="" />
                <div className={`introduction-title ${styles['introduction-title']}`}>
                    <div className={`title-wrapper ${styles['title-wrapper']}`}>
                        <img src={leftBall} alt="" />
                        <div className={`title-container ${styles['title-container']}`}>
                            <div>
                                <p><span>ACE</span><span>—— 智能低代码开发工具</span></p>
                                <p>智能低代码开发工具集场景需求分析、界面搭建、数据对接三大核心能力于一体，基于丰富的应用架构模板，在可视化页面通过简单操作即可灵活搭建应用，完美适配多类业务场景，大幅提升应用产出效率。</p>
                            </div>
                            <img src={acepages} alt="" />
                        </div>
                    </div>
                </div>
            </div>
            <div className={styles['feature-container']}>
                <p>产品特色</p>
                <div className={styles['feature-content']}>
                    <div className={`feature-item ${styles['feature-item']}`}>
                        <div className={styles['img']}></div>
                        <p>低代码</p>
                        <p>优化开发流程，一站式低代码构建</p>
                    </div>
                    <div className={`feature-item ${styles['feature-item']}`}>
                        <div className={styles['img']}></div>
                        <p>高效率</p>
                        <p>快速构建页面，提高项目产出效率</p>
                    </div>
                    <div className={`feature-item ${styles['feature-item']}`}>
                        <div className={styles['img']}></div>
                        <p>可共享</p>
                        <p>业务沉淀，减少重复开发工作</p>
                    </div>
                    <div className={`feature-item ${styles['feature-item']}`}>
                        <div className={styles['img']}></div>
                        <p>便捷化</p>
                        <p>“拖、拉、拽”式的便捷化操作</p>
                    </div>
                </div>
            </div>
        </>)
    }
];

function ApplicationDevelopmentTools() {
    return (
        <div className={`production-introduction-wrapper ${styles['application-dev-wrapper']}`}>
            <div className={`banner ${styles['banner']}`}>
                <div className="title">大数据智能化产品</div>
                <div className={`content ${styles['content']}`}>烽火星空大数据智能化系列产品作为行业解决方案的核心技术支撑，主要包括大数据平台、数据治理工具、分析建模工具、应用开发工具，贯穿数据的存算、分析、应用、展示全生命周期，是新时代信息领域的“大国重器”</div>
            </div>

            <div className={styles['application-dev-container']}>
                <Tabs
                    defaultActiveKey='1'
                    centered
                    destroyInactiveTabPane
                    items={applicationList.map((item) => (
                        {
                            label: item.label,
                            key: item.key,
                            children: item.content
                        }
                    ))}
                />
            </div>
        </div>
    )
}

export default ApplicationDevelopmentTools